"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const material_1 = require("@mui/material");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const q_play_core_1 = require("@nordicscreen/q-play-core");
const Settings_module_css_1 = __importDefault(require("../public/Settings.module.css"));
const AdvancedSelect_1 = __importDefault(require("../Select/AdvancedSelect"));
const ColorPicker_1 = __importDefault(require("../ColorPicker/ColorPicker"));
const MediaLibraryButton_1 = __importDefault(require("../Button/MediaLibraryButton"));
const SettingsComponent = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const [, triggerReRender] = (0, react_1.useState)(false);
    let layoutClass = Settings_module_css_1.default["settings-default-layout"];
    switch (props.setting.layout) {
        case "narrow":
            layoutClass = Settings_module_css_1.default["settings-narrow-layout"];
            break;
        case "wide":
            layoutClass = Settings_module_css_1.default["settings-wide-layout"];
            break;
        case "full":
            layoutClass = Settings_module_css_1.default["settings-full-layout"];
            break;
    }
    let elementStyle = {};
    switch (props.setting.alignment) {
        case "right":
            elementStyle = { textAlign: "right" };
            break;
        case "center":
            elementStyle = { textAlign: "center" };
            break;
    }
    let primitiveValue = null;
    let objectValue = null;
    switch (typeof props.value) {
        case "string":
        case "number":
        case "boolean":
            primitiveValue = props.value;
            break;
        case "undefined":
            primitiveValue = undefined;
            objectValue = undefined;
            break;
        case "object":
            objectValue = props.value;
            break;
    }
    const SettingLabel = ({ label, description, dataCy }) => (description ? (react_1.default.createElement(material_1.Tooltip, { title: description, placement: "top" },
        react_1.default.createElement("span", { className: Settings_module_css_1.default["settings-label"], "data-cy": dataCy },
            label,
            ":",
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-circle-question", style: { marginLeft: "5px" } })))) : (react_1.default.createElement("span", { className: Settings_module_css_1.default["settings-label"], "data-cy": dataCy },
        label,
        ":")));
    (0, react_1.useEffect)(() => {
        if (props.setting instanceof q_play_core_1.SelectSetting) {
            props.setting.ruleManager.initRules().then((shouldUpdate) => {
                if (shouldUpdate) {
                    triggerReRender(prev => !prev);
                }
            });
        }
    }, [props.setting]);
    const dataCy = "setting-" + props.setting.key;
    if (props.setting instanceof q_play_core_1.BooleanSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", name: `setting[${props.setting.key}]`, checked: props.setting.extract(primitiveValue) === "1", readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["boolean-input-field"]}`, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.IntegerSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("input", { type: "number", step: props.setting.step, value: props.setting.extract(primitiveValue), min: props.setting.extract(props.setting.minValue), max: props.setting.extract(props.setting.maxValue), readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["integer-input-field"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.DecimalSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("input", { type: "number", step: props.setting.step, value: props.setting.extract(primitiveValue), min: props.setting.minValue, max: props.setting.maxValue, readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["decimal-input-field"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.NumberRangeSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("div", { className: Settings_module_css_1.default["range-input-container"] },
                react_1.default.createElement(react_bootstrap_1.Form.Range, { step: props.setting.step, value: props.setting.extract(primitiveValue), min: props.setting.minValue, max: props.setting.maxValue, readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: props.setting.showInputField ? Settings_module_css_1.default["range-input-field-with-addon"] : Settings_module_css_1.default["range-input-field"], onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-range` }),
                props.setting.showInputField
                    ? react_1.default.createElement("input", { type: "number", step: props.setting.step, value: props.setting.extract(primitiveValue), min: props.setting.minValue, max: props.setting.maxValue, readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["range-input-field-addon"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })
                    : react_1.default.createElement(react_1.default.Fragment, null))));
    }
    else if (props.setting instanceof q_play_core_1.SelectSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { name: `setting[${props.setting.key}]`, value: (_a = props.setting.extract(primitiveValue)) !== null && _a !== void 0 ? _a : "", disabled: props.disabled, className: `${Settings_module_css_1.default["select-input-field"]}`, style: elementStyle, onChange: props.onChange, key: props.setting.key, "data-key": props.setting.key, "data-cy": `${dataCy}-input` }, props.setting.options.map((option) => {
                if (props.setting instanceof q_play_core_1.SelectSetting) {
                    return (react_1.default.createElement("option", { key: `value ${option.value}`, value: option.value, disabled: props.setting.ruleManager.evaluateValue(option) }, option.label));
                }
                else {
                    return (react_1.default.createElement("option", { key: `value ${option.value}`, value: option.value }, option.label));
                }
            }))));
    }
    else if (props.setting instanceof q_play_core_1.PasswordSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("input", { type: "password", name: `setting[${props.setting.key}]`, value: (_b = props.setting.extract(primitiveValue)) !== null && _b !== void 0 ? _b : "", readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["password-input-field"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.TextSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("textarea", { name: `setting[${props.setting.key}]`, value: (_c = props.setting.extract(primitiveValue)) !== null && _c !== void 0 ? _c : "", readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, cols: props.setting.cols, rows: props.setting.rows, className: `${Settings_module_css_1.default["textarea-input-field"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.ColorSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement(ColorPicker_1.default, { hexa: (_d = props.setting.extract(primitiveValue)) !== null && _d !== void 0 ? _d : "#000000FF", placement: props.setting.placement, hideColorPalette: props.setting.hideColorPalette, hideAlpha: props.setting.hideAlpha, disabled: props.disabled || props.setting.readonly, callback: props.onChange, dataKey: props.setting.key })));
    }
    else if (props.setting instanceof q_play_core_1.MediaLibrarySetting) {
        const hydratedValue = props.setting.hydrate(props.value);
        const safeOrigin = (_e = props.setting.origin) === null || _e === void 0 ? void 0 : _e.trim();
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": `setting-${props.setting.key}` },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `setting-${props.setting.key}-label` }),
            react_1.default.createElement(MediaLibraryButton_1.default, { value: hydratedValue, onChange: (file) => {
                    if (typeof props.onChange === 'function') {
                        if (props.onChange.length >= 2) {
                            props.onChange(file, props.setting.key);
                        }
                        else {
                            const syntheticEvent = {
                                target: {
                                    value: file,
                                    dataset: { key: props.setting.key }
                                },
                                currentTarget: {
                                    value: file,
                                    dataset: { key: props.setting.key }
                                },
                                preventDefault: () => { },
                                stopPropagation: () => { }
                            };
                            props.onChange(syntheticEvent);
                        }
                    }
                }, onClear: () => {
                    if (typeof props.onChange === 'function') {
                        if (props.onChange.length >= 2) {
                            props.onChange(null, props.setting.key);
                        }
                        else {
                            const syntheticEvent = {
                                target: {
                                    value: null,
                                    dataset: { key: props.setting.key }
                                },
                                currentTarget: {
                                    value: null,
                                    dataset: { key: props.setting.key }
                                },
                                preventDefault: () => { },
                                stopPropagation: () => { }
                            };
                            props.onChange(syntheticEvent);
                        }
                    }
                }, mimeGroup: props.setting.mimeGroup, origin: safeOrigin, disabled: props.disabled || props.setting.readonly })));
    }
    else if (props.setting instanceof q_play_core_1.StringSetting) {
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement("input", { type: "text", name: `setting[${props.setting.key}]`, value: (_f = props.setting.extract(primitiveValue)) !== null && _f !== void 0 ? _f : "", readOnly: props.disabled || props.setting.readonly, disabled: props.disabled, className: `${Settings_module_css_1.default["text-input-field"]}`, style: elementStyle, onChange: props.onChange, "data-key": props.setting.key, "data-cy": `${dataCy}-input` })));
    }
    else if (props.setting instanceof q_play_core_1.AdvancedSelectSetting) {
        let fieldWidth = "50%";
        switch (props.setting.layout) {
            case "narrow":
                fieldWidth = "25%";
                break;
            case "wide":
                fieldWidth = "75%";
                break;
            case "full":
                fieldWidth = "100%";
                break;
        }
        return (react_1.default.createElement("div", { className: `${Settings_module_css_1.default["setting"]} ${layoutClass}`, "data-cy": dataCy },
            react_1.default.createElement(SettingLabel, { label: props.setting.label, description: props.setting.description, dataCy: `${dataCy}-label` }),
            react_1.default.createElement(AdvancedSelect_1.default, { valueSelectCallback: props.onChange, option_object: props.setting.option_object, placeholder: props.setting.placeholder, no_option_text: props.setting.no_option_text, width: fieldWidth, disabled: props.disabled, readOnly: props.disabled || props.setting.readonly, selected_value: (_g = props.setting.extract(objectValue)) !== null && _g !== void 0 ? _g : undefined, dataKey: props.setting.key })));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null));
    }
};
exports.default = SettingsComponent;
